
import { Vue, Component, Prop } from 'vue-property-decorator'
import { NoteImage } from 'features/typescript/notes/notes'
import ImgZoomable from '../../Images/ImgZoomable.vue'

@Component({
  components: {
    ImgZoomable
  }
})
export default class ImagesPreview extends Vue {
  @Prop({ required: true }) images!: (File | string | NoteImage)[]
  @Prop({ default: true }) editable!: boolean

  dialog = false
  selectedImage: File | string | NoteImage | null = null

  getImageUrl(img: File | string | NoteImage | null): string {
    if (!img) return ''
    if (typeof img === 'string') return img
    if (img instanceof File) return URL.createObjectURL(img)
    if (typeof img === 'object' && 'signed_url' in img) return (img as NoteImage).signed_url
    return ''
  }

  openDialog(img: File | string | NoteImage) {
    this.selectedImage = img
    this.dialog = true
  }
}
